import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/account_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  address_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'address',
  },
  city_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'city',
  },
  email_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'email',
  },
  name_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'name',
  },
  number_digest_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'numberDigest',
  },
  phone_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'phone',
  },
  referrer_cont: {
    model_name: 'Account',
    column_type: 'string',
    column_name: 'referrer',
  },
  status_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Account',
      options: ['pending', 'approved', 'rejected'],
    },
    model_name: 'Account',
    column_name: 'status',
  },
  is_staff_eq: {
    column_type: 'boolean',
    model_name: 'Account',
    column_name: 'isStaff',
  },
  risk_assessment_level_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Account',
      options: ['C1', 'C2', 'C3', 'C4', 'C5'],
    },
    model_name: 'Account',
    column_name: 'riskAssessmentLevel',
  },
  certificate_end_date_gteq: {
    column_type: 'date',
    model_name: 'Account',
    column_name: 'certificateEndDate',
  },
  certificate_end_date_lteq: {
    column_type: 'date',
    model_name: 'Account',
    column_name: 'certificateEndDate',
  },
  type_eq: {
    column_type: 'type',
    extra: {
      options: ['PersonalAccount', 'CompanyAccount', 'ProductAccount', 'AgentAccount'],
    },
    model_name: 'Account',
    column_name: 'type',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Account',
      options: ['internal', 'external'],
    },
    model_name: 'Account',
    column_name: 'kind',
  },
  agent_target_id_eq: {
    column_type: 'belongs_to',
    column_name: 'agent_target',
    extra: {
      model_name: 'Account',
    },
    model_name: 'Account',
  },
  agent_target: {
    column_type: 'belongs_to',
    column_name: 'agent_target',
    extra: {
      model_name: 'Account',
    },
    model_name: 'Account',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Account', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Account', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
